import { SVGProps } from "react";

export default function BrokenLinkIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 12, width = 12, stroke = "#AE372A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.52992 5.47021C7.65492 6.59521 7.65492 8.41521 6.52992 9.53521C5.40492 10.6552 3.58492 10.6602 2.46492 9.53521C1.34492 8.41021 1.33992 6.59021 2.46492 5.47021"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.29547 6.70494C4.12547 5.53494 4.12547 3.63494 5.29547 2.45994C6.46547 1.28494 8.36547 1.28994 9.54047 2.45994C10.7155 3.62994 10.7105 5.52994 9.54047 6.70494"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
